import { LayoutGrid } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { CatalogPage } from "@/components/common/CatalogPage";
import { categoriesApi } from "@/lib/api";
import type { ProductCategory } from "@/lib/api/types";

/** Marketplace product categories. */
export default function CategoriesPage() {
  return (
    <CatalogPage<ProductCategory>
      queryKey="product-categories"
      title="Product categories"
      subtitle={(n) => `${n} categories that group marketplace products.`}
      icon={LayoutGrid}
      noun="category"
      searchPlaceholder="Search categories…"
      source={{
        kind: "list",
        fetch: categoriesApi.list,
        searchText: (c) => `${c.name} ${c.nameSwahili}`,
      }}
      itemLabel={(c) => c.name}
      columns={[
        { header: "Name", render: (c) => <span className="font-semibold">{c.name}</span> },
        { header: "Swahili", render: (c) => c.nameSwahili },
        { header: "Icon", render: (c) => c.iconName ?? "—" },
        { header: "Status", render: (c) => (c.isActive === false ? <Badge variant="muted">Hidden</Badge> : <Badge variant="success">Active</Badge>) },
      ]}
      fields={[
        { key: "name", label: "Name (English)", required: true, half: true, placeholder: "Vitamins" },
        { key: "nameSwahili", label: "Name (Swahili)", required: true, half: true, placeholder: "Vitamini" },
        { key: "description", label: "Description", type: "textarea" },
        { key: "iconName", label: "Icon name", placeholder: "e.g. pill" },
        { key: "isActive", label: "Active (shown in the app)", type: "checkbox", defaultChecked: true },
      ]}
      create={categoriesApi.create}
      update={categoriesApi.update}
      remove={categoriesApi.remove}
    />
  );
}
